module.exports = __webpack_public_path__ + "img/health.7c1879ea.jpeg";